import {useState, ReactNode} from 'react';
import './_v-button.scss';

export type VButtonProps = {
    content: string | ReactNode;
    width?: string;
    height?: string;
    borderRadius?: string;
    padding?: string;
    className?: string;
    id?: string;
    tooltip?: string;
    tooltipPosition?: string;
    onClick?: () => void;
}

export default function VButton({content, width, height, borderRadius, padding, className, id, onClick, tooltip, tooltipPosition}: VButtonProps) {
    const [isHovered, setIsHovered] = useState(false);
    const [_timeOut, _setTimeOut] = useState<any>(null);

    function onMouseEnter() {
        setIsHovered(true);
    }

    function onMouseLeave() {
        setIsHovered(false);
    }

    return <button id={id}
                   className={"v-button " + (className)}
                   style={{width, height, borderRadius, padding}}
                   onClick={onClick}
                   onMouseEnter={onMouseEnter}
                   onMouseLeave={onMouseLeave}
    >
        {content}
        {tooltip && <span className={'v-button__tooltip' + (isHovered ? ' show' : '') + (tooltipPosition ? ' ' + tooltipPosition : '')}>{tooltip}</span>}
    </button>;
}
